<script setup>
    import { ref } from 'vue';
    import axios from 'axios';
    import * as bootstrap from 'bootstrap';

    const props = defineProps(['fetchUrl']);

    const newSuspendedUser = ref({
        Rechnungsempfaengernummer: '',
        nupsiId: '',
        name: '',
        lot: '',
        reason: '',
    });

    const submitResult = ref(null);
    const submitError = ref(null);

    // loads a bootstrap modal after saving the new suspended user.
    // Modal disappears after 5 seconds, site reloads half a second later.
    async function saveNewSuspended() {
        submitResult.value = null;
        submitError.value = null;
        await axios.post(props.fetchUrl, newSuspendedUser.value)
        .then(function (response) {
            submitResult.value = response;
            setTimeout(function() {
                const currentModal = document.querySelector('#createSuspendedUser');
                const modal = bootstrap.Modal.getInstance(currentModal);
                modal.hide();
            }, 5000);
            setTimeout(function() {
                window.location.reload();
            }, 5500);
        }).catch(function (error) {
            submitError.value = error;
        });
    }


</script>

<template>
    <form @submit.prevent="submit">
        <div class="form-group">
            <label for="Rechnungsempfaengernummer">Rechnungsempfängernummer (*)</label>
            <input id="Rechnungsempfaengernummer"
                type="text"
                v-model="newSuspendedUser.Rechnungsempfaengernummer"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.Rechnungsempfaengernummer !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Rechnungsempfaengernummer !== 'undefined')">
                {{ submitError.response.data.Rechnungsempfaengernummer[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="nupsiId">Nupsi-ID</label>
            <input id="nupsiId"
                type="text"
                v-model="newSuspendedUser.nupsiId"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.nupsiId !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.nupsiId !== 'undefined')">
                {{ submitError.response.data.nupsiId[0] }}
            </div>
        </div>
        <div class="form-group">
            <label for="name">Nachname (*)</label>
            <input id="name"
                type="text"
                v-model="newSuspendedUser.name"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.name !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.name !== 'undefined')">
                {{ submitError.response.data.name[0] }}
            </div>
        </div>
        <div class="form-group">
            <label for="lot">Parkplatz/-objekt</label>
            <input id="lot"
                type="text"
                v-model="newSuspendedUser.lot"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.lot !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.lot !== 'undefined')">
                {{ submitError.response.data.lot[0] }}
            </div>
        </div>
        <div class="form-group">
            <label for="reason">Grund/Forderung</label>
            <input id="reason"
                type="text"
                v-model="newSuspendedUser.reason"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.reason !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.reason !== 'undefined')">
                {{ submitError.response.data.reason[0] }}
            </div>
        </div>
        <p>Felder mit einem * sind Pflichtfelder.</p>
        <button type="submit" class="btn btn-primary" @click.prevent="saveNewSuspended()">Nutzer sperren</button>
    </form>
    <div class="alert alert-success" role="alert" v-if="submitResult !== null && (submitResult.status === 201 || submitResult.status === 200)">
        <span>Nutzer erfolgreich gesperrt.</span>
    </div>
</template>
